export enum ParticipantLimitMode {
  UNLIMITED = 'UNLIMITED',
  LIMITED = 'LIMITED',
}
